import { UserUserNameFollowingsGetInputModel } from "./GetInputModel"
import { httpGet } from "../../../../../libs/http/httpGet"

export const GetUserUserNameFollowings = (
  model: UserUserNameFollowingsGetInputModel,
): Promise<number> => {
  return httpGet<number>("/v1/user/{user_name}/followings", model)
}
